import React, { Component } from 'react'
import { Link } from 'react-router'

import classNames from './Navigation.css'
import EditUser from './modals/EditUser'
import { userHasPerm, isSuperAdmin } from '../utils/auth'

export default class Navigation extends Component {
  state = {
    showProfile: false
  }
  componentWillReceiveProps (nextProps) {
    document.body.style.overflow = nextProps.open ? 'hidden' : ''
  }
  hideProfile = () => {
    this.setState({ showProfile: false })
  }
  getSections () {
    const { logout, user, anonymousUser } = this.props
    return [
      {
        title: 'Browse',
        shouldShow: !anonymousUser,
        items: [
          {
            text: 'Home',
            href: '/'
          },
          {
            text: 'Albums',
            href: '/albums'
          },
          {
            text: 'Search',
            href: '/search',
            shouldShow: userHasPerm(user, 'search_and_save')
          },
          {
            text: 'Timeline',
            href: '/timeline',
            shouldShow: userHasPerm(user, 'search_and_save')
          },
          {
            text: 'Album Hierarchy',
            href: '/hierarchy',
            shouldShow: userHasPerm(user, 'view_hierarchy')
          }
        ]
      },
      {
        title: 'Manage',
        shouldShow: !anonymousUser,
        items: [
          {
            text: 'Album Groups',
            href: '/groups'
          },
          {
            text: 'Playlists',
            href: '/playlists',
            shouldShow: userHasPerm(user, 'create_channels')
          },
          {
            text: 'Queues',
            href: '/queues',
            shouldShow: userHasPerm(user, 'create_channels')
          },
          {
            text: 'Channels',
            href: '/channels',
            shouldShow: userHasPerm(user, 'create_channels') || userHasPerm(user, 'view_shared_channels')
          },
          {
            text: 'Orchestra 1',
            href: '/orchestras',
            shouldShow: userHasPerm(user, 'create_channels') || userHasPerm(user, 'view_shared_channels') // TODO: create dedicated Orchestra permissions
          },
          {
            text: 'Orchestra 2',
            href: '/orchestras2',
            shouldShow: userHasPerm(user, 'create_channels') || userHasPerm(user, 'view_shared_channels') // TODO: create dedicated Orchestra permissions
          },
          {
            text: 'Orchestra TV 1',
            href: '/orchestra-tv',
            shouldShow: userHasPerm(user, 'create_channels') || userHasPerm(user, 'view_shared_channels') // TODO: create dedicated Orchestra permissions
          },
          {
            text: 'Orchestra TV 2',
            href: '/orchestra-tv2',
            shouldShow: userHasPerm(user, 'create_channels') || userHasPerm(user, 'view_shared_channels') // TODO: create dedicated Orchestra permissions
          }
        ]
      },
      {
        title: 'Admin',
        shouldShow: userHasPerm(user, 'admin') || userHasPerm(user, 'dynamic_links') || userHasPerm(user, 'external_share') || isSuperAdmin(user),
        items: [
          {
            text: 'Manage Users',
            href: '/users',
            shouldShow: userHasPerm(user, 'admin')
          },
          {
            text: 'Manage External Share Codes',
            href: '/shares',
            shouldShow: userHasPerm(user, 'external_share')
          },
          {
            text: 'Manage Dynamic Tables',
            href: '/dynamics',
            shouldShow: userHasPerm(user, 'dynamic_links')
          },
          {
            text: 'Manage Libraries',
            href: '/libraries',
            shouldShow: isSuperAdmin(user)
          },
          {
            text: 'Manage Keyword Visibility',
            href: '/manage-keyword-visibility',
            shouldShow: isSuperAdmin(user)
          },
          {
            text: 'Manage Keyword Weighting',
            href: '/manage-keyword-weighting',
            shouldShow: isSuperAdmin(user)
          },
          {
            text: 'Manage Keyword Updates',
            href: '/manage-keyword-updates',
            shouldShow: isSuperAdmin(user)
          },
          {
            text: 'Scripts Info',
            href: '/scripts',
            shouldShow: isSuperAdmin(user)
          }
        ]
      },
      {
        title: 'User',
        items: [
          {
            text: 'Edit Profile',
            onClick: () => this.setState({ showProfile: true }),
            shouldShow: !anonymousUser
          },
          {
            text: 'Image Configuration',
            href: '/settings',
            shouldShow: userHasPerm(user, 'image_config') || isSuperAdmin(user)
          },
          {
            text: 'Manage Sessions',
            href: '/sessions',
            shouldShow: !anonymousUser
          },
          {
            text: 'Log out',
            onClick: logout
          }
        ]
      }
    ]
  }
  render () {
    const { open, closeNav, user, updateUser } = this.props
    const wrapperClass = open ? classNames.wrapperOpen : classNames.wrapper
    const navClass = open ? classNames.navOpen : classNames.nav
    return (
      <div>
        <div className={wrapperClass} onClick={closeNav}>
          <nav className={navClass}>
            {open && this.getSections().map(renderSection)}
          </nav>
        </div>
        {this.state.showProfile &&
          <EditUser
            title='Profile'
            showPasswordField
            onSubmit={data => updateUser(user.id, data).then(success => success && this.hideProfile())}
            onCancel={this.hideProfile}
            initialValues={{
              name: user.name,
              email: user.email,
              password: user.password,
              location: user.location
            }}
          />
        }
      </div>
    )
  }
}

function renderSection ({ shouldShow, title, items }) {
  if (typeof shouldShow !== 'undefined' && !shouldShow) {
    return null
  }
  return (
    <section key={title}>
      <div className={classNames.heading}>
        {title}
      </div>
      <ul className={classNames.list}>
        {items.map(renderItem)}
      </ul>
    </section>
  )
}

// Stolen from components/Menu
function renderItem ({ text, onClick, href, shouldShow, ...props }) {
  if (typeof shouldShow !== 'undefined' && !shouldShow) {
    return null
  }
  if (href) {
    return (
      <li key={text} className={classNames.item}>
        <Link to={href} className={classNames.link} {...props}>
          {text}
        </Link>
      </li>
    )
  }
  return (
    <li key={text} className={classNames.item}>
      <button onClick={onClick} className={classNames.link} {...props}>
        {text}
      </button>
    </li>
  )
}



// WEBPACK FOOTER //
// ./src/components/Navigation.js